import { createStorageAtomFactory, withSerialization } from '@exodus/atoms'
import { FiatOrderSet } from '@exodus/models'

const createFiatOrdersAtom = ({ storage }) => {
  const deserialize = (value) => FiatOrderSet.fromArray(value)
  const serialize = (value) => value?.toJSON()
  const atomFactory = createStorageAtomFactory({ storage })
  const atom = atomFactory({
    key: 'fiatOrders',
    defaultValue: [],
    isSoleWriter: true,
  })

  return withSerialization({ atom, deserialize, serialize })
}

const fiatOrdersAtomDefinition = {
  id: 'fiatOrdersAtom',
  type: 'atom',
  factory: createFiatOrdersAtom,
  dependencies: ['storage'],
  public: true,
}

export default fiatOrdersAtomDefinition
